import { EventEmitter } from 'events'

class AlertModalManager extends EventEmitter {

  openModal(content, onCloseHandler, closeOnDimmerClick) {
    this.emit('open', { content, onCloseHandler, closeOnDimmerClick })
  }
}

export default new AlertModalManager()